/** @jsx jsx */
import { jsx } from 'theme-ui'
import ModalPopupLink from './moreInfoButton'

const MoreWinnersCard = ({
  awardTitle,
  awardSubtitle,
  winnersLogo,
  href,
  awardLabel,
  providerName,
  ctaText,
  ctaTextMobile,
  ctaHref,
  modalContent
}) => (
  <div
    sx={{
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
      borderRadius: '8px',
      maxWidth: 300,
      backgroundColor: 'white',
      m: '0 auto',
      textAlign: 'left',
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontSize: [14, 16]
    }}
  >
    <div
      sx={{
        background: 'white',
        pt: [16, 14],
        px: 16,
        flexGrow: 1
      }}
    >
      <div
        sx={{
          mb: '16px',
          fontSize: ['12px', '14px']
        }}
      >
        {awardLabel}
      </div>

      {winnersLogo}

      <h6 sx={{ fontSize: '18px', fontWeight: 700, mt: 16, flex: 1 }}>
        {awardTitle}
      </h6>
      {awardSubtitle && (
        <p sx={{ fontSize: '18px', mb: 16, flex: 1, lineHeight: 'initial' }}>
          {awardSubtitle}
        </p>
      )}
    </div>
    <div
      sx={{
        mt: '16px',
        px: 16,
        backgroundColor: '#F3F3F3',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        height: ['110px', '112px']
      }}
    >
      <ModalPopupLink
        text={`Why ${providerName} won`}
        href={href}
        modalContent={modalContent}
      />
      {ctaHref && ctaText && (
        <a
          href={ctaHref}
          target="_blank"
          rel="noreferrer"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            p: '6px 8px',
            width: '100%',
            border: '1px solid black',
            borderRadius: '2px',
            background: '#FFF',
            m: '0 auto',
            fontWeight: 700
          }}
        >
          <div
            sx={{
              display: ['inline-block', 'none'],
              width: '100%',
              textAlign: 'center',
              m: 0,
              p: 0
            }}
          >
            {ctaTextMobile || 'View deals'}
          </div>
          <div
            sx={{
              display: ['none', 'inline-block'],
              width: '100%',
              textAlign: 'center'
            }}
          >
            {ctaText}
          </div>
        </a>
      )}
    </div>
  </div>
)

export default MoreWinnersCard
